import React from 'react';
import {twMerge} from 'tailwind-merge';

interface LinearTextProps {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
}

const LinearText: React.FC<LinearTextProps> = ({children, className, as: Tag = 'span'}) => {
    const gradientStyles =
        'bg-clip-text text-transparent bg-[linear-gradient(to_right,#0041EA_0%,#FF31D2_76%,#FF398C_100%)]';

    const combinedClassName = twMerge(gradientStyles, className);

    return <Tag className={combinedClassName}>{children}</Tag>;
};

export default LinearText;
